module.exports = __webpack_public_path__ + "pattern_landscape.6dd16803.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/pattern_landscape.svg
// module id = VbZG
// module chunks = 0